import '../../monitoring/filters/date/applied_date_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.AppliedDateView extends Monitoring.Views.SocialContents.Filters.AppliedDateView
  initialize: ({searchQuery, title, removable}) ->
    super(searchQuery: searchQuery)
    @removable = if removable == false then false else true
    @title = title || I18n.t('profiling.dashboard.fields.creation_date')

  getRenderParameters: ->
    _.extend(super(), removable: @removable)

  removeDateFrom: => @removeDate()
  removeDateTo: => @removeDate()
  removeDateFromRealtime: => @removeDate()

  removeDate: =>
    @searchQuery.removeDateFrom()
    @searchQuery.removeDateTo()
    @searchQuery.removeDateFromRealtime()
    @searchQuery.triggerFilterChanged()
